
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import chill from "../../icons/photos/chillLogo.png"
import videoCallImg from '../../media/images/serviceImg.gif'
import './twilio.scss'

import { useTheme } from "@emotion/react";
import { useLocation, useNavigate } from "react-router-dom";
import { BsStarFill } from 'react-icons/bs';
import { BiStar } from 'react-icons/bi';
import CameraAlertImg from '../../media/images/CameraAlertImg.png'

import { Button, Col, Modal, Spinner } from "react-bootstrap";
import InputField from "../../jsx/components/fields/inputField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import TextArea from "../../jsx/components/fields/textArea";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { userById } from "../../service/api/user/userById";
import { setLoaderTime, setNotificationCount, setUserDetails } from "../../feature/userData/userData";
import { unreadNotificationCount } from "../../service/api/notification/unreadNotification";
import CallRating from "./callRating";
import VideoCallPreview from "./videoPreview";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import MessageAlertModal from "../../jsx/components/resultModal/messageAlertModal";

const Lobby = ({
  name,
  handleUsernameChange,
  roomName,
  handleRoomNameChange,
  handleSubmit,
  connecting,
  error,
  handleParticipantAlert,
  limitExceedParticipant, participantText,
  ratingDialogValue,
  closeRatingDialogFn,
  handleRatingOnChange,
  handleRatingValue,
  handleFeedbackMessageChange,
  handleFeedbackMessageValue,
  closeRatingDialogFnOnly,
  remoteParId, ratingValueEmp, cameraPermission, handleCameraClose,
  responceMsg,
  toasterType,
  handleToaster,
  handleTimerStop,
  startTimeFlow,
  handleDeviceSelection,
  participantNameArr,
  socket,
  joinCallRes,
  handleUpdateForEstimationReport,
}) => {
  const { authorized } = useSelector((state) => state.auth)
  const { role, userName, phoneCodeRedux, phoneNumberRedux, emailRedux, impersonateFlag } = useSelector((state) => state.user);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [ratingModalTrigger, setRatingModalTrigger] = useState(false)
  const [appLink, setAppLink] = useState("https://chilll.page.link/inviteFriend")
  const [secondsRemaining, setSecondsRemaining] = useState(40);
  const [isTimeUp, setIsTimeUp] = useState(false);
  const [stopTimer, setStopTimer] = useState(0)
  const request_url = "https://app.chilll.com"

  useEffect(() => {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('roomId')) {
      const roomId = urlParams.get('roomId')
      localStorage.setItem("roomCode", roomId)

    }
  }, [])

  useEffect(() => {

    // Set the timer only if secondsRemaining is greater than 0
    if (startTimeFlow) {
      if (secondsRemaining > 0) {
        const intervalId = setInterval(() => {
          setSecondsRemaining((seconds) => seconds - 1);
        }, 1000);

        // Clear the interval on component unmount or when the countdown finishes
        return () => clearInterval(intervalId);
      } else {
        setIsTimeUp(true);
        setSecondsRemaining(40)
        // Call the function when time is up
        onTimeUp();
      }
    }
  }, [secondsRemaining, startTimeFlow]);

  const onTimeUp = () => {
    setStopTimer(stopTimer + 1)
    if (stopTimer < 2) {
      handleSubmit()

    } else { handleTimerStop() }

    // Perform any action you need when the time is up
  };

  useEffect(() => {
    console.log(ratingModalTrigger);
  }, [ratingModalTrigger])

  const handleBack = () => {
    navigate('/dashboard')
  }


  useEffect(() => {

    const url = 'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyDcF8ay48oU_Dn_u9CziCz7dm7EYEgzkb0'
    const payload = {
      "dynamicLinkInfo": {
        "domainUriPrefix": "chilll.page.link",
        "link": request_url,
        // "link":'https://app.chilll.com/app/?roomId={room_id}&page=video',
        "androidInfo": {
          "androidPackageName": "com.chilll.app"
        },
        "iosInfo": {
          // "iosBundleId": "com.chilll.app",
          "iosBundleId": `${process.env.REACT_APP_DEEPLINK_IOS_ID}`,
          "iosAppStoreId": "1621747291"
        },
        "navigationInfo": {
          "enableForcedRedirect": 1,
        },
      }
    }
    const otherPram = {
      "headers": {
        "content-type": "application/json; charset=UTF-8"
      },
      "body": JSON.stringify(payload),
      "method": "POST"
    }

    fetch(url, otherPram)
      .then(data => { return data.json() })
      .then(res => {



        setAppLink(res["shortLink"])

      })
      .catch(error => console.log(error))
  }, [])

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('roomId')) {

      const roomId = urlParams.get('roomId')
      localStorage.setItem("roomCode", roomId)

    }

    if (authorized) {
      let user = {
        user_id_ids: localStorage.getItem("user_id") || "",
        role_id_int: localStorage.getItem("roleId"),
        user_impersonate_flag: 0
      };
      dispatch(
        userById(user, (res) => {
          dispatch(setUserDetails(res.data.data));
          dispatch(setLoaderTime(res.data))
          // console.log(`${res.data.data.is_active_ysn} res.data.data.is_active_ysn`)
          localStorage.setItem("triggerFlag", res.data.data.is_available_ysn)
        })
      );

    }
  }, [])

  const handleRatingOpen = (e) => {
    e.stopPropagation();
    setRatingModalTrigger(true)
  }

  return (
    <>

      <div style={{ width: '100vw', height: '100vh', display: 'flex' }}>

        {!ratingDialogValue ?
          (<VideoCallPreview
            onChange={handleUsernameChange}
            value={name}
            errorOccured={error}
            handleSubmit={handleSubmit}
            isLoading={connecting}
            participantNameArr={participantNameArr}
            onDeviceSelection={(a, d) => { handleDeviceSelection(a, d) }}
          />) :

          (<CallRating onClose={closeRatingDialogFn} joinCallRes={joinCallRes} handleUpdateForEstimationReport={handleUpdateForEstimationReport} />)}
      </div>




      {limitExceedParticipant && (

        <>
          <MessageAlertModal
            text={participantText == "Please join after few seconds." ? "Maximum participant limit reached" : participantText}

            onClose={
              () => { handleTimerStop() }
            }

            modalStatus={limitExceedParticipant}

          />

        </>
      )}

      {/* <Modal className="fade" show={true} style={{}}>
            <div className='d-flex align-items-center justify-content-center' style={{ padding: '30px', flexDirection: 'column' }}>
              <div style={{
                fontSize: '18px',
                fontWeight: '600',
                textAlign: 'center',
                padding: '20px',
              }}>

                <p>{participantText == "Please join after few seconds." ?"Maximum participant limit reached" : participantText}  </p> 
         
              </div>

           {  startTimeFlow ? <div>
              Please hold on , we are connecting you
              </div>:""}

              <PrimaryButton onClick={handleTimerStop} buttonName={"Ok"} style={{width:'100%',background:'red'}}/>
            </div>
          </Modal> */}


      {/* Camera Modal */}

      <Modal className="fade" show={cameraPermission}
      // onHide={handleClose} 
      >
        <Modal.Header style={{ borderBottom: 'none' }}>
          <Modal.Title>Camera Alert</Modal.Title>
          <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={handleCameraClose}
          >

          </Button>
        </Modal.Header>

        <Modal.Body>
          <p>Chilll requires access to your camera and microphone. Click camera blocked icon in your browser's address bar or check you have valid source of mic and video</p>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img src={CameraAlertImg} alt='Error camera alert' style={{ boxShadow: '1px 1px 6px 2px black', borderRadius: '8px' }} />
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
            <PrimaryButton buttonName={'Dismiss'} style={{ width: '100%' }} onClick={handleCameraClose} />
          </div>
        </Modal.Body>
      </Modal>

      {/* {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />} */}

      {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}


    </>
  );
};

export default Lobby;
